<template>
  <v-dialog v-model="dialog" max-width="900" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ 'app.shopping_list_combining' | trans }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-layout row justify-end>
            <v-flex xs6>
              <v-autocomplete
                  v-model="selectedPatientId"
                  @change="patientChanged"
                  solo
                  :items="patients"
                  item-text="name"
                  item-value="id"
                  :label="'app.search.search' | trans"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 v-if="selectedCombinedMenus.length " class="text-left">
              <label class="control-label">{{ 'app.selected_menus'|trans }}:</label>
              <ul class="selected-menus">
                <li v-for="selectedMenu in selectedCombinedMenus" class="selected-menu">
                  <span>{{ selectedMenu.patient.first_name }} {{
                      selectedMenu.patient.last_name
                    }} {{ selectedMenu.start_date|format_date() }} - {{ selectedMenu.end_date|format_date() }}</span>
                  <v-btn outline small icon :color="`red`"
                         @click="removeMenu(selectedMenu)"
                  >
                    <v-icon v-bind="{small: true}">delete</v-icon>
                  </v-btn>
                </li>
              </ul>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <menu-table
                  @menu-selected="menuSelected"
                  :mode="'select'"
                  ref="menuTable"
                  v-if="selectedPatientId"
                  :patient_id="selectedPatientId"></menu-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import {mapGetters, mapMutations} from "vuex";

export default {
  data: () => ({
    dialog: false,
    selectedPatientId: null,
    patients: [],
  }),
  computed: {
    ...mapGetters([
      'selectedCombinedMenus',
    ]),
  },
  methods: {
    ...mapMutations([
      'setSelectedCombinedMenus',
    ]),
    close() {
      this.selectedPatientId = null;
      this.dialog = false;

    },
    show() {
      this.dialog = true;
      this.fetchPatients();
    },
    async fetchPatients() {
      const response = await axios.get(`/patients/data?is_active=true`);
      this.patients = response.data.data.map((patient) => {
        return {
          id: patient.id,
          name: `${patient.first_name} ${patient.last_name}`
        };
      })
    },
    menuSelected(menu) {
      this.selectedCombinedMenus.push(menu);
      this.fetchMenus();
      this.$emit('change');
    },
    patientChanged() {
      this.fetchMenus();
    },
    fetchMenus() {
      if (this.$refs.menuTable) {
        this.$refs.menuTable.triggerFetchMenus(null, this.selectedPatientId);
      }
    },
    removeMenu(menu) {
      let selectedCombinedMenus = this.selectedCombinedMenus.filter((selectedMenu) => {
        return selectedMenu.uuid !== menu.uuid;
      });
      this.setSelectedCombinedMenus(selectedCombinedMenus);
      if (this.selectedPatientId) {
        this.fetchMenus();
      }
      this.$emit('change');
    }
  },
};
</script>

<style scoped>
.selected-menus {
  list-style: none;
  padding-left: 0;
}

.selected-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>